import React from 'react'
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom'

// High-level components (routes)
import SaleRequest from './SaleRequest'
import SaleTransaction from './SaleTransaction'

/** Outer shell of the app - hosts URL routes to top-level components */
const App = () => (
  <Router>
    <Switch>
      <Route exact path='/sale/new' component={SaleRequest} />
      <Route exact path='/transaction/:id' component={SaleTransaction} />
      {/* Default landing page */}
      <Redirect to='/sale/new' />
    </Switch>
  </Router>
)

export default App
